import { createAdaptiveBotPolicy, ADAPTIVE_BOT_ID, ADAPTIVE_BOT_VERSION } from '../implementations/adaptive/adaptive-bot';
import { createClassicBotPolicy, CLASSIC_BOT_ID, CLASSIC_BOT_VERSION } from '../implementations/classic/classic-bot';
import { ADAPTIVE_DECK_POLICY_ID, ADAPTIVE_DECK_POLICY_VERSION, MANUAL_DECK_POLICY_ID, MANUAL_DECK_POLICY_VERSION, selectAdaptiveDeck, selectManualDeck } from '../deck/deck-selector';
import type { BotDefinition } from './types';

const DEFINITIONS: readonly BotDefinition[] = Object.freeze([
  {
    id: CLASSIC_BOT_ID,
    name: 'Classic',
    nameKey: 'bot.classic',
    version: CLASSIC_BOT_VERSION,
    deckPolicyId: MANUAL_DECK_POLICY_ID,
    deckPolicyVersion: MANUAL_DECK_POLICY_VERSION,
    supportsLearning: false,
    supportedRulesets: ['towerarena-1v1'],
    createPolicy: createClassicBotPolicy,
    selectDeck: ({ manualDeck }) => selectManualDeck(manualDeck),
  },
  {
    id: ADAPTIVE_BOT_ID,
    name: 'Adaptive counter bot',
    nameKey: 'bot.adaptive',
    version: ADAPTIVE_BOT_VERSION,
    deckPolicyId: ADAPTIVE_DECK_POLICY_ID,
    deckPolicyVersion: ADAPTIVE_DECK_POLICY_VERSION,
    supportsLearning: true,
    supportedRulesets: ['towerarena-1v1'],
    createPolicy: createAdaptiveBotPolicy,
    selectDeck: ({ content, model, seed, manualDeck }) => selectAdaptiveDeck(content, model, seed, manualDeck),
  },
]);

const REGISTRY = new Map(DEFINITIONS.map((definition) => [definition.id, definition]));

export function getBotDefinition(id: string): BotDefinition {
  const definition = REGISTRY.get(id);
  if (!definition) throw new Error(`Unknown bot definition: ${id}`);
  return definition;
}

export function listBotDefinitions(): readonly BotDefinition[] {
  return DEFINITIONS;
}
